var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/AdvertisingBanner/AdvertisingBanner.jinja"] = require( "front/components/AdvertisingBanner/AdvertisingBanner.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/AdvertisingBanner/AdvertisingBanner.jinja", false, "assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "AdvertisingBanner")) {
var t_7 = t_4.AdvertisingBanner;
} else {
cb(new Error("cannot import 'AdvertisingBanner'")); return;
}
context.setVariable("AdvertisingBanner", t_7);
if(Object.prototype.hasOwnProperty.call(t_4, "ADVERTISING_PERSPECTIVE_1")) {
var t_8 = t_4.ADVERTISING_PERSPECTIVE_1;
} else {
cb(new Error("cannot import 'ADVERTISING_PERSPECTIVE_1'")); return;
}
context.setVariable("ADVERTISING_PERSPECTIVE_1", t_8);
output += "\n\n";
frame = frame.push();
var t_11 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("article", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "<li data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),t_8) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),t_8)) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
output += "class=\"noborder\"";
;
}
output += ">\n        <a class=\"PerspectiveArticlesListInner-article\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"url"), env.opts.autoescape);
output += "\">\n            <div class=\"PerspectiveArticlesListInner-articleImg\">\n                ";
if(runtime.memberLookup((t_12),"cover")) {
output += "<img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"cover")),"w440_url"), env.opts.autoescape);
output += "\"\n                  srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"cover")),"w680_url"), env.opts.autoescape);
output += " 2x\"\n                  alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"title"), env.opts.autoescape);
output += "\">\n                ";
;
}
output += "</div>\n            <div class=\"PerspectiveArticlesListInner-articleInfo\">\n                <div class=\"PerspectiveArticlesListInner-articleTitle\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"title"), env.opts.autoescape);
output += "</div>\n                <div class=\"PerspectiveArticlesListInner-articleDetails\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_12),"shortText")), env.opts.autoescape);
output += "</div>\n            </div>\n            <div class=\"PerspectiveArticlesListInner-articleArrow\">\n                ";
output += runtime.suppressValue((lineno = 20, colno = 38, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_13 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_14 = "";;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
return macro_t_13;})()})])), env.opts.autoescape);
output += "\n            </div>\n        </a>\n    </li>\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),t_8) && env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),t_8)) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
output += "\n        <div class=\"PerspectiveArticlesList-advertisingBannerWrapper\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            ";
output += runtime.suppressValue((lineno = 27, colno = 30, runtime.callWrap(t_7, "AdvertisingBanner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"advertising")),t_8),"size": "wide","position": "PERSPECTIVE – POSITION 1"})])), env.opts.autoescape);
output += "\n        </div>\n    ";
;
}
output += "\n";
;
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.jinja
// module id = 123
// module chunks = 0